module.exports = __webpack_public_path__ + "a8e1ac584d625beeb4da1d25a61500b5.svg";